<div class="card loading" [ngClass]="additionalClasses">
  <div class="card__image">
    <figure></figure>
  </div>

  @if (hasText) {
    <div class="card__text">
      <h4 class="card__title">{{ 'general.label.loading' | translate }}</h4>
      <div class="card__description">
        <p>{{ 'general.label.loading' | translate }}</p>
      </div>
    </div>
  }
</div>
